import React, { useState, useEffect } from "react";
import {
  Button,
  Form,
  Input,
  Select,
  Row,
  Col,
  Space,
  Table,
  Tag,
  message,
} from "antd";
import {
  LinkedinFilled,
  BulbFilled,
  RocketFilled,
  ControlFilled,
  GoldenFilled,
} from "@ant-design/icons";
import axios from "axios";
import moment from "moment/moment";
import localhost from "../../constants/localhost";

const data = Array(10)
  .fill(null)
  .map((_, index) => {
    return {
      id: index + 1,
      title: "夏尔预约试驾详情页",
      type: "达人分享",
      abstract:
        "捷途山海L9，是捷途汽车全新打造的新能源序列首款产品，产品定位“大家庭大七座超混SUV”，搭载奇瑞鲲鹏超能混动C-DM技术，主打空间大、油耗省、动力强的产品优势，覆盖家庭旅行混动出行的使用场景。",
      status: "已结束",
      comments: "567",
      score: 5,
      downloads: "188",
      amountAfForwarding: "366",
      citations: "135",
      author: "晓梦",
      releaseTime: "2024-07-24 09:56:25",
      updateTime: "2024-08-11 09:56:25",
      endTime: "2025-6-20 13:20:11",
    };
  });

const PublicDomain = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [form] = Form.useForm();
  const [pageInfo, setPageInfo] = useState({ pageNo: 1, pageSize: 10 });
  const [dataInfo, setDataInfo] = useState({
    total: 20,
    dataSource: data,
  });
  const [loading, setLoading] = useState(false);

  const getData = () => {
    setLoading(true);
    const formData = form.getFieldsValue();
    if (formData.releaseDate) {
      formData.releaseDateStart = moment(formData.releaseDate[0]).format(
        "YYYY-MM-DD"
      );
      formData.releaseDateEnd = moment(formData.releaseDate[1]).format(
        "YYYY-MM-DD"
      );
      formData.releaseDate = undefined;
    }
    axios
      .post(`${localhost}/manage/distributionPlan/queryList`, {
        pageNo: 1,
        pageSize: 20,
        ...formData,
      })
      .then((res) => {
        setDataInfo({
          total: res?.data?.total || 0,
          dataSource: res?.data?.list || [],
        });
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const pagination = {
    showTotal: (total, range) => {
      return `当前第 ${range[0]} 到 ${range[1]} 条，总共${total}条数据`;
    },
    total: dataInfo.total,
    current: pageInfo.pageNo,
    pageSize: pageInfo.pageSize,
    onChange: (page, pageSize) => {
      setPageInfo({ pageNo: page, pageSize: pageSize }, () => {
        getData();
      });
    },
    onShowSizeChange: (current, size) => {
      setPageInfo({ pageNo: current, pageSize: size }, () => {
        getData();
      });
    },
  };

  useEffect(() => {
    getData();
  }, []);

  const onSearch = () => {
    setPageInfo({ pageNo: 1, pageSize: 10 });
    getData();
  };

  const onReset = () => {
    form.resetFields();
    setPageInfo({ pageNo: 1, pageSize: 10 });
    getData();
  };

  const onDelete = (id) => {
    axios
      .get(`${localhost}/manage/distributionPlan/delete?id=${id}`)
      .then((res) => {
        message.success("删除成功！");
        setPageInfo({ pageNo: 1, pageSize: 10 });
        getData();
      })
      .catch((error) => {
        message.error("网络异常，请重试！");
      });
  };

  const formStyle = {
    maxWidth: "none",
    padding: 24,
  };

  const onFinish = (values) => {
    console.log("Received values of form: ", values);
  };

  const iconStyle = {
    color: "#3b81e3",
    fontSize: 46,
    marginRight: 16,
  };
  const statistic = [
    {
      icon: <ControlFilled style={iconStyle} />,
      text: "分发量",
      num: 1256,
    },
    {
      icon: <BulbFilled style={iconStyle} />,
      text: "曝光量",
      num: 123987,
    },
    {
      icon: <RocketFilled style={iconStyle} />,
      text: "点击量",
      num: 6554,
    },
    {
      icon: <LinkedinFilled style={iconStyle} />,
      text: "访问量",
      num: 9888,
    },
    {
      icon: <GoldenFilled style={iconStyle} />,
      text: "转发量",
      num: 7899,
    },
  ];

  const columns = [
    {
      title: "作品ID",
      dataIndex: "id",
      key: "id",
      fixed: "left",
      minWidth: 120,
    },
    {
      title: "作品名称",
      dataIndex: "title",
      key: "title",
      fixed: "left",
      minWidth: 120,
      render: (text) => <a>{text}</a>,
    },
    {
      title: "标签",
      dataIndex: "type",
      key: "type",
      minWidth: 120,
      render: (val) => <Tag color="magenta">{val}</Tag>,
    },
    {
      title: "简介",
      dataIndex: "abstract",
      key: "abstract",
      minWidth: 120,
    },
    {
      title: "状态",
      dataIndex: "status",
      key: "status",
      minWidth: 120,
    },
    {
      title: "‌评论数",
      dataIndex: "comments",
      key: "comments",
      minWidth: 120,
    },
    {
      title: "‌评分",
      dataIndex: "score",
      key: "score",
      minWidth: 120,
    },
    {
      title: "下载量",
      dataIndex: "downloads",
      key: "downloads",
      minWidth: 120,
    },
    {
      title: "转发量",
      dataIndex: "amountAfForwarding",
      key: "amountAfForwarding",
      minWidth: 120,
    },
    {
      title: "引用次数",
      dataIndex: "citations",
      key: "citations",
      minWidth: 120,
    },
    {
      title: "作者",
      dataIndex: "author",
      key: "author",
      minWidth: 120,
    },
    {
      title: "发布时间",
      dataIndex: "releaseTime",
      key: "releaseTime",
      minWidth: 120,
    },
    {
      title: "更新时间‌",
      dataIndex: "updateTime",
      key: "updateTime",
      minWidth: 120,
    },
    {
      title: "结束时间",
      dataIndex: "endTime",
      key: "endTime",
      minWidth: 120,
    },
    {
      title: "操作",
      key: "action",
      fixed: "right",
      minWidth: 120,
      render: (_, record) => (
        <Space size="middle">
          <a>查看</a>
          <a>编辑</a>
          <a>引用</a>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <p>数据统计</p>
      <div
        style={{
          padding: 32,
          border: "1px solid #d3d3d3",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {statistic.map((item, index) => {
            return (
              <div
                key={index}
                style={{
                  padding: 16,
                  background: "#f8f8f8",
                }}
              >
                <div style={{ display: "flex" }}>
                  {item.icon}
                  <div>
                    <div
                      style={{
                        color: "#3b81e3",
                        fontSize: 22,
                        textAlign: "center",
                        marginBottom: 8,
                      }}
                    >
                      {item.num}
                    </div>
                    <div style={{ fontWeight: 500, fontSize: 26 }}>
                      {item.text}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div>
        <Form
          form={form}
          name="advanced_search"
          style={formStyle}
          onFinish={onFinish}
        >
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item name="title" label="作品名称">
                <Input placeholder="请输入作品名称" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="author" label="状态">
                <Select placeholder="请选择状态" allowClear>
                  <Select.Option value="t1">待投放</Select.Option>
                  <Select.Option value="t2">投放中</Select.Option>
                  <Select.Option value="t3">已结束</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <div style={{ textAlign: "right" }}>
                <Space size="small">
                  <Button type="primary">搜索</Button>
                  <Button>重置</Button>
                </Space>
              </div>
            </Col>
          </Row>
        </Form>
      </div>

      <div>
        <Table
          columns={columns}
          scroll={{ x: "max-content", y: "calc(100vh - 360px - 55px - 64px)" }}
          style={{
            height: "calc(100vh - 360px)",
            overflowY: "scroll",
          }}
          rowSelection={{
            selectedRowKeys,
            onChange: (keys, selectedRows) => {
              console.log("selectedRowKeys changed: ", keys);
              setSelectedRowKeys(keys);
            },
          }}
          dataSource={dataInfo.dataSource}
          // loading={loading}
          pagination={pagination}
        />
      </div>
    </div>
  );
};

export default PublicDomain;
